var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = { class: "prod-delivery__wrap" };
var _hoisted_2 = { class: "prod-delivery__item prod-delivery__item--moscow" };
var _hoisted_3 = { class: "prod-delivery__label tooltip-wrapper" };
var _hoisted_4 = { class: "prod-delivery__item prod-delivery__item--spb" };
var _hoisted_5 = { class: "prod-delivery__label" };
var _hoisted_6 = {
    key: 0,
    class: "prod-delivery__item prod-delivery__item--regions"
};
var _hoisted_7 = { class: "prod-delivery__label" };
var _hoisted_8 = { class: "prod-delivery__value" };
var _hoisted_9 = {
    key: 1,
    class: "prod-delivery__item prod-delivery__item--regions"
};
var _hoisted_10 = { class: "prod-delivery__ctrl" };
var _hoisted_11 = ["data-extra-day"];
import { computed, ref, watch } from "vue";
import { getLocation, isMoscow as testMoscow, isStPetersburg as testStPetersburg } from "../../../../components/location";
import Price from "../../../../components/Price.vue";
import Tooltip from "../../../../components/Tooltip.vue";
import { ContentLoader } from "vue-content-loader";
import { useDeliveryApi } from "../../../../api/deliveryApi";
import { addDays } from "date-fns";
import EventBus from "../../../../events/EventBus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeliveryInfo',
    props: {
        moscow: { type: String, required: true },
        stPetersburg: { type: String, required: true },
        extraDay: Boolean,
        sameDayPrice: Number,
    },
    setup: function (__props) {
        var props = __props;
        var deliveryApi = useDeliveryApi();
        var location = ref(getLocation());
        var isMoscow = computed(function () { return location.value ? testMoscow(location.value) : true; });
        var isStPetersburg = computed(function () { return location.value ? testStPetersburg(location.value) : false; });
        var isRegions = computed(function () { return !(isMoscow.value || isStPetersburg.value); });
        var className = computed(function () { return ({
            'prod-delivery--moscow': isMoscow.value,
            'prod-delivery--spb': isStPetersburg.value,
            'prod-delivery--regions': isRegions.value,
        }); });
        var button = ref();
        var loading = ref(isRegions.value);
        var STORAGE_NAME = "regions-delivery-days".concat(props.extraDay ? '2' : '');
        var deliveryDays = ref();
        EventBus.on('city:update', function (newLocation) { return location.value = newLocation; });
        watch([isRegions, location], function (_a) {
            var _b = __read(_a, 1), isRegions = _b[0];
            if (isRegions) {
                updateRegionDays();
            }
        });
        updateRegionDays();
        function updateRegionDays() {
            if (isRegions.value) {
                var cachedDays = getCachedDays();
                if (cachedDays) {
                    deliveryDays.value = cachedDays;
                    loading.value = false;
                }
                else {
                    getDays();
                }
            }
        }
        function getDays() {
            loading.value = true;
            deliveryApi.getDeliveryInfo(location.value.region, location.value.fias, location.value.zip, props.extraDay, location.value.insideBeltway)
                .then(function (response) {
                loading.value = false;
                deliveryDays.value = response.days;
                localStorage.setItem(STORAGE_NAME, JSON.stringify({
                    fias: location.value.fias,
                    days: response.days,
                    valid: addDays(new Date(), 7).toJSON(),
                }));
            });
        }
        function getCachedDays() {
            var _a;
            var cachedDeliveryDays = JSON.parse((_a = localStorage.getItem(STORAGE_NAME)) !== null && _a !== void 0 ? _a : 'null');
            if (!cachedDeliveryDays || cachedDeliveryDays.fias !== location.value.fias || cachedDeliveryDays.valid <= new Date().toJSON()) {
                return false;
            }
            return cachedDeliveryDays.days;
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["prod-delivery", className.value])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createTextVNode(_toDisplayString(isMoscow.value ? 'Доставим ' : '') + " ", 1 /* TEXT */),
                            _createElementVNode("button", {
                                class: "link link--dashed tooltip-btn",
                                type: "button",
                                ref_key: "button",
                                ref: button,
                                "aria-describedby": "moscow_tooltip"
                            }, _toDisplayString(__props.moscow), 513 /* TEXT, NEED_PATCH */),
                            _cache[3] || (_cache[3] = _createTextVNode()),
                            _createVNode(Tooltip, {
                                button: button.value,
                                id: "moscow_tooltip"
                            }, {
                                default: _withCtx(function () { return [
                                    _cache[1] || (_cache[1] = _createElementVNode("p", null, "Доставка по Москве день в день (в пределах МКАД) возможна при заказе до 14:00 с понедельника по пятницу.", -1 /* CACHED */)),
                                    _cache[2] || (_cache[2] = _createTextVNode()),
                                    _createElementVNode("p", null, [
                                        _cache[0] || (_cache[0] = _createTextVNode("Стоимость доставки ", -1 /* CACHED */)),
                                        _createElementVNode("strong", null, [
                                            _createVNode(Price, { amount: __props.sameDayPrice }, null, 8 /* PROPS */, ["amount"])
                                        ])
                                    ])
                                ]; }),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["button"])
                        ]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "prod-delivery__value" }, "по Москве", -1 /* CACHED */))
                    ]),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(isStPetersburg.value ? 'Доставим ' : '') + _toDisplayString(__props.stPetersburg), 1 /* TEXT */),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "prod-delivery__value" }, "в Санкт-Петербург", -1 /* CACHED */))
                    ]),
                    _cache[13] || (_cache[13] = _createTextVNode()),
                    (isRegions.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _cache[8] || (_cache[8] = _createTextVNode("Доставим\n          ", -1 /* CACHED */)),
                                (loading.value)
                                    ? (_openBlock(), _createBlock(_unref(ContentLoader), {
                                        key: 0,
                                        width: "85",
                                        height: "14",
                                        class: "delivery-loader"
                                    }))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode("за " + _toDisplayString(deliveryDays.value), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                            ]),
                            _cache[9] || (_cache[9] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_8, "в " + _toDisplayString(location.value.type === 'г' ? 'г ' : '') + _toDisplayString(location.value.name), 1 /* TEXT */)
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, __spreadArray([], __read((_cache[10] || (_cache[10] = [
                            _createElementVNode("div", { class: "prod-delivery__label" }, "3-10 дней", -1 /* CACHED */),
                            _createTextVNode(),
                            _createElementVNode("div", { class: "prod-delivery__value" }, "по регионам", -1 /* CACHED */)
                        ]))), false))),
                    _cache[14] || (_cache[14] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn--2 btn--m btn--black win",
                            "data-act": "delivery_calculator",
                            "data-extra-day": __props.extraDay
                        }, __spreadArray([], __read((_cache[11] || (_cache[11] = [
                            _createElementVNode("span", { class: "btn__label" }, "Рассчитать", -1 /* CACHED */)
                        ]))), false), 8 /* PROPS */, _hoisted_11)
                    ])
                ])
            ], 2 /* CLASS */));
        };
    }
});
